<template>
    <div id="BindPhone">
        <transition name="scale">
            <div class="centerPanel">
                <div class="userphone_con">
                    <div class="full">
                        <div class="alert_title flex  ac">
                            <img src="./img/icon_img21.png"
                                 @click="close"
                                 class="close" />
                        </div>
                        <div class="desc">
                            <p class="c-fff">手机快速绑定</p>
                            <p>绑定完成后，您将可以使用手机快速登录当前账号</p>
                        </div>
                        <div class="form">
                            <div class="input flex jb ac">
                                <input type="text"
                                       v-model="phone"
                                       maxlength="11"
                                       placeholder="请输入手机号">
                                <span v-if="time_space">{{time_space}}秒后重新获取</span>
                                <span @click="send_code" v-else>发送验证码</span>
                            </div>
                            <div class="input">
                                <input type="text"
                                       v-model="code"
                                       maxlength="6"
                                       placeholder="请输入验证码">
                            </div>
                        </div>
                        <div class="submit" @click="bind_phone_code">
                            确定绑定
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data () {
        return {
            phone: '',
            code: '',
            //短信验证码倒计时
            counting: false,
            time_space: 0,
            timer:null
        }
    },
    created () {

    },
    methods: {
        fetchProfile(){
            this.$http.get(`/front/user/profile/`).then(res => {
                if (res.status == '200') {
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setIsLogin', true)
                }
            }).finally(() => {

            })
        },
        //关闭绑定手机弹窗
        close () {
            this.$store.commit('setShowBindPhone', false)
        },
        //点击获取验证码
        send_code () {
            if (this.time_space != 0) {
                return
            }
            let check_phone_res = this.check_phone(this.phone)
            if (!check_phone_res) {
                return
            }
            //如果手机号码校验通过
            this.$http.post(`/front/auth/smscode/`, {
                'phone':this.phone,
                'tpl_id':SMS_TPL_ID
            }).then(res => {
                if (res.status == '200') {
                    this.$toast("验证码已发送，请注意查收");
                    this.time_space = 60
                    this.timer = setInterval(() => {
                        this.time_space--;
                        if (this.time_space === 0) {
                            clearInterval(this.timer); // 清除定时器
                        }
                    }, 1000);
                }else{
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    })
                }
            })
        },
        bind_phone_code () {
            let check_phone_res = this.check_phone(this.phone)
            if (!check_phone_res) {
                return
            }
            if (!this.code.length) {
                this.$toast("验证码不得为空");
                return
            }
            this.$http.put(`/front/user/bind/phone/`, {
                phone: this.phone,
                code: this.code
            }).then(res => {
                if (res.status == '200') {
                    this.$toast("绑定成功");
                    this.fetchProfile()
                    this.close()
                }else{
                    this.$message({
                        message: res.message,
                        type: 'warning',
                    })
                }
            }).catch(res=>{
                this.$toast(res.data.message);
            })
        },
        check_phone (phone) {
            // 定义手机号码的正则表达式
            if(!phone){
                this.$toast("请填写手机号");
                return false;
            }
            const regex = /^1[3456789]\d{9}$/;
            if (!regex.test(phone)) {
                this.$toast("手机号码格式不正确");
                return false;
            } else {
                return true
            }
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#BindPhone {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .userphone_con {
            width: 440px;
            padding: 20px;
            background-color: #1e1f22;
            border: 2px solid #5865f2;
            border-radius: 6px;
            .full {
                position: relative;
                display: flex;
                flex-direction: column;
                height: 100%;
                .alert_title {
                    justify-content: end;
                    .close {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;
                    }
                }
                .desc {
                    text-align: center;
                    font-size: 14px;
                    .c-fff {
                        font-size: 16px;
                        margin-bottom: 10px;
                    }
                }
                .form {
                    padding: 0 30px 50px;
                    .input {
                        border: 2px solid #36373d;
                        background: #2b2d31;
                        padding: 9px 12px;
                        border-radius: 8px;
                        margin-top: 25px;
                        input {
                            height: 30px;
                            line-height: 30px;
                            flex: 1;
                            border: 0;
                            background: transparent;
                            color: #fff;
                            font-size: 14px;
                        }
                        span {
                            cursor: pointer;
                            margin-left: 20px;
                            color: #5865f2;
                            &:hover {
                                color: #5865f2cc;
                            }
                            font-size:14px;
                        }
                    }
                }
                .submit {
                    margin: 0 30px 50px;
                    cursor: pointer;
                    background-color: #5865f2;
                    color: #fff;
                    border-radius: 6px;
                    line-height: 53px;
                    text-align: center;
                    font-size: 16px;
                    &:hover {
                        background-color: rgba(88, 101, 242, 0.867);
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>